import PaymentDeleteConfirmModal from "./PaymentDeleteConfirmModal";
import PaymentDetailsModal from "./PaymentDetailsModal";
import PaymentsSummaryCard from "./PaymentsSummaryCard";
import PaymentsLedgerTable from "./tables/PaymentsLedgerTable";
import { Stack } from "@mui/material";
import Component from "components/Component";
import Button from "components/common/Button";
import { useState } from "react";
import { useSelector } from "react-redux";
import * as submissionsService from "services/submissionsService";
import * as persistenceSelectors from "store/selectors/persistence/persistenceSelectors";

const Payments = () => {
  const submissionId = useSelector(persistenceSelectors.selectSubmissionId);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deletePayment] = submissionsService.useDeletePaymentMutation();
  const [editTarget, setEditTarget] = useState(null);

  const { data, isLoading } = submissionsService.useListPaymentsQuery(
    { submissionId },
    { skip: !submissionId }
  );

  const boundLayers = data?.boundLayers || [];
  const paymentsMade = data?.paymentsMade || [];

  const handleConfirmDelete = async () => {
    if (deleteTarget) {
      await deletePayment({
        submissionId,
        layerId: deleteTarget.layerId,
        paymentId: deleteTarget.paymentId,
      });
    }
    setDeleteTarget(null);
  };

  return (
    <Component
      title={"Payments"}
      loading={isLoading}
      options={
        <Button
          color={"primary"}
          onClick={() => setIsCreateOpen(true)}
          isDisabled={boundLayers.length === 0}
          tooltip={"Payments can only be recorded against a bound layer"}
          tooltipRequired={boundLayers.length === 0}
        >
          {"Add Payment"}
        </Button>
      }
    >
      <Stack spacing={4} sx={{ padding: 2 }}>
        <PaymentsSummaryCard
          boundLayers={boundLayers}
          paymentsMade={paymentsMade}
        />
        <PaymentsLedgerTable
          boundLayers={boundLayers}
          paymentsMade={paymentsMade}
          onRequestEdit={(row) => setEditTarget(row)}
        />
        <PaymentDetailsModal
          open={isCreateOpen}
          onClose={() => setIsCreateOpen(false)}
          mode={"create"}
        />
        <PaymentDetailsModal
          open={Boolean(editTarget)}
          onClose={() => setEditTarget(null)}
          mode={"edit"}
          payment={editTarget}
          onRequestDelete={(payment) => {
            setEditTarget(null);
            setDeleteTarget(payment);
          }}
        />
        <PaymentDeleteConfirmModal
          open={Boolean(deleteTarget)}
          onCancel={() => setDeleteTarget(null)}
          onConfirm={handleConfirmDelete}
        />
      </Stack>
    </Component>
  );
};

export default Payments;
